import './Divider.css'

function Divider() {
  return (
    <section className="ko-divider">
      <hr />
    </section>
  )
}

export default Divider
